import { Component, Vue } from 'vue-property-decorator';
import { Events } from '@/events';
import { sessionService } from '@/providers/services/auth/session';


@Component({ name: 'app-header-nav' })
export default class AppHeaderNav extends Vue {

  // -------------------------------------------------------------------------
  //  Properties

  private currentRoutePath: string = '/network';


  private submenuStyle: any = {};

  private menuItems: any = [];
  // -------------------------------------------------------------------------
  // Computed Properties

  get isTenantAdmin() {
    const report  = this.$access.menus;
    return this.$access.hasMenuAccess(report.reports);
  }

  // -------------------------------------------------------------------------
  //  Hooks
  public created() {
    this.menuItems = sessionService.headerMenuOnPermission();
  }

  public mounted() {
    this.currentRoutePath = this.$router.currentRoute.path;
  }

  // -------------------------------------------------------------------------
  //  Actions

  private onChangeRoute(currentPath: string) {
    this.currentRoutePath = currentPath;
    this.$router.push(currentPath);
    this.$emit('send', currentPath);
  }

  private onloadMenuList(item: any) {
    if (this.isTenantAdmin && item.key === this.$access.menus.network) {
      return this.$access.menus.reports;
    } else if (this.isTenantAdmin && item.key === this.$access.menus['data-lake']) {
      return 'Learing Registry';
    } else {
      return item.name;
    }
  }
}
